

import ImageGallery from "../components/sections/image-gallary";
import GalleryMain from "../assets/images/gallery/gallery-2.jpg";
import { useState, useEffect } from "react";
import { Col, Container, Row, Spinner, Alert } from "react-bootstrap";
import { Banner } from '@veeyaainnovatives/banner';
import axios from 'axios';
import { getApiUrl } from '../config/api';

import Bannerimg from '../assets/images/gallery/gallery-3.jpg';

const Gallery = () => {
  const [portfolioItems, setPortfolioItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const pageDetails = {
    title: "Our **Portfolio**",
    description: "Explore our comprehensive service packages and solutions designed to meet your needs.",
    breadcrumb: [
      { name: "Home", link: "/" },
      { name: "Portfolio", link: "/portfolio" }
    ],
  }

  // Fetch portfolio from API
  useEffect(() => {
    const fetchPortfolio = async () => {
      try {
        setLoading(true);
        setError('');
        
        const response = await axios.get(getApiUrl('api/public/portfolio'));
        
        if (response.data.success && response.data.data) {
          // Map API response to component structure
          const mappedItems = response.data.data.map(item => ({
            id: item.id,
            url: item.url,
            title: item.title,
            filename: item.filename,
            mime_type: item.mime_type,
            file_size: item.file_size
          }));
          
          setPortfolioItems(mappedItems);
        } else {
          setPortfolioItems([]);
        }
      } catch (error) {
        console.error('Error fetching portfolio:', error);
        setError('Failed to load portfolio. Please try again later.');
        setPortfolioItems([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolio();
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <style>{`
        .portfolio-image-wrapper {
          position: relative;
          overflow: hidden;
        }
        
        /* Title overlay on image (visible by default, hidden on hover) */
        .portfolio-title-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.6) 50%, transparent 100%);
          padding: 20px 15px 15px 15px;
          z-index: 2;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }
        
        /* Hide title overlay on hover */
        .portfolio-image-wrapper:hover .portfolio-title-overlay {
          opacity: 0;
        }
        
        .portfolio-item-title-overlay {
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;
          margin: 0;
          line-height: 1.4;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
      <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
      <div className="body-wrap overflow-hidden">
        <Container>
          <h1 className="about-us-title text-center my-5">Give a peek into our <span className="theme-color-green"> Work <br className='d-none d-lg-block' /> done</span>  </h1>
          <div className="pt-4 position-relative">
            <div className="design-circle-upcoming-batch position-absolute"></div>
            <ImageGallery img={GalleryMain} />
          </div>
        </Container>

        <section className="section">
          <Container >
            {/* className="my-5 pt-5" */}
            <h1 className="sds-work-title mb-4 pt-5 pt-md-0"> Showcasing Excellence in Every Project </h1>
            <p className="our-work-desc pb-5">Explore our diverse portfolio showcasing exceptional architectural designs, interior transformations, and construction projects. Each project represents our commitment to excellence, innovation, and client satisfaction. From modern residential spaces to commercial developments, witness the artistry and precision that defines our work.</p>

            {/* Loading State */}
            {loading && (
              <div className="text-center py-5">
                <Spinner animation="border" role="status" style={{ color: '#677a58' }}>
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p className="mt-3">Loading portfolio...</p>
              </div>
            )}

            {/* Error State */}
            {error && (
              <Alert variant="danger" className="mb-4">
                <Alert.Heading>Error</Alert.Heading>
                <p>{error}</p>
              </Alert>
            )}

            {/* Portfolio Grid */}
            {!loading && !error && (
              <>
                {portfolioItems.length > 0 ? (
                  <Row>
                    {portfolioItems.map((item) => (
                      <Col lg={6} key={item.id}>
                        <div className="studen-work-card mb-4">
                          <div className='img-1'>
                            <div 
                              style={{ backgroundImage: `url(${item.url})` }} 
                              className="blog-card-img img-1 mb20 portfolio-image-wrapper"
                              title={item.title || item.filename}
                            >
                              {/* Title overlay on image (always visible at bottom) */}
                              <div className="portfolio-title-overlay">
                                <h5 className="portfolio-item-title-overlay">
                                  {item.title || item.filename}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <div className="text-center py-5">
                    <p className="text-muted">No portfolio items available at the moment.</p>
                  </div>
                )}
              </>
            )}
          </Container>
        </section>

      </div>
    </>
  )
}

export default Gallery;